import { AlertBreeze, BodySmall, BreezeIcon, Checkbox, LayoutBox, LayoutHorizontal } from 'breeze-intelligence-kit';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import { ObjectTypeLabel } from '../EnrichableObjectTypesProvider';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function EnrichAssociatedRecords({
  associatedObjectType,
  checked,
  onChange
}) {
  function handleCheckboxChange() {
    onChange(!checked);
  }
  return /*#__PURE__*/_jsx(AlertBreeze, {
    children: /*#__PURE__*/_jsxs(LayoutBox, {
      paddingBlock: "space-xs",
      children: [/*#__PURE__*/_jsx(AlertBreeze.Title, {
        paddingBlockEnd: "space-sm",
        children: /*#__PURE__*/_jsxs(LayoutHorizontal, {
          gap: "space-xs",
          children: [/*#__PURE__*/_jsx(BreezeIcon, {}), /*#__PURE__*/_jsx(FormattedMessage, {
            message: "enrichmentProperties.modals.enrichAssociated.title"
          })]
        })
      }), /*#__PURE__*/_jsx(BodySmall, {
        children: /*#__PURE__*/_jsx(FormattedReactMessage, {
          message: "enrichmentProperties.modals.enrichAssociated.descriptionWithoutCount",
          options: {
            objectType: /*#__PURE__*/_jsx(ObjectTypeLabel, {
              isCapitalized: false,
              isPlural: true,
              type: associatedObjectType
            })
          }
        })
      }), /*#__PURE__*/_jsx(Checkbox, {
        alignment: "center",
        checked: checked,
        onChange: handleCheckboxChange,
        children: /*#__PURE__*/_jsx(Checkbox.Label, {
          fontSize: "md",
          children: /*#__PURE__*/_jsx(FormattedReactMessage, {
            message: "enrichmentProperties.modals.enrichAssociated.toggleLabel",
            options: {
              objectType: /*#__PURE__*/_jsx(ObjectTypeLabel, {
                isCapitalized: false,
                type: associatedObjectType
              })
            }
          })
        })
      })]
    })
  });
}